module.exports = __webpack_public_path__ + "static/media/metamask 1.3b154f88.svg";